import { di } from 'react-magnetic-di';

import { useUIModificationsConsentStatusForApps } from '../../adjustments-context/hooks/use-consent-status';
import { UIM_CONSENT_REQUIRED } from '../../adjustments-context/types';
import { useFieldIsProcessing } from '../../issue-adjustments/hooks/use-field-is-processing';

/**
 * Hook covers the blocking (loading) UIM functionality:
 * - when UIM error occurred @see `useFieldIsProcessing` it returns false - fields are NOT blocked
 * - scenarios with consent and registering fields: see unit tests.
 */
export const useFieldIsBusy = (fieldId: string) => {
	di(useFieldIsProcessing);
	const [isBusyData] = useFieldIsProcessing(fieldId);
	const uimConsentMap = useUIModificationsConsentStatusForApps();
	const { isBusy, appsIds } = isBusyData;

	if (!isBusy) {
		return false;
	}

	return appsIds.some((appId) => uimConsentMap[appId] !== UIM_CONSENT_REQUIRED);
};
